import { render, staticRenderFns } from "./VideoRoomChatMessage.vue?vue&type=template&id=05aae6e0&scoped=true&"
import script from "./VideoRoomChatMessage.vue?vue&type=script&lang=js&"
export * from "./VideoRoomChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomChatMessage.vue?vue&type=style&index=0&id=05aae6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aae6e0",
  null
  
)

export default component.exports